import { render, staticRenderFns } from "./ShowDocumentAdjustment.vue?vue&type=template&id=4658661e&"
import script from "./ShowDocumentAdjustment.vue?vue&type=script&lang=js&"
export * from "./ShowDocumentAdjustment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports